export default __webpack_public_path__ + "static/media/code.7772f908.png";